import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { DonutChart } from '../../../../core/components/DonutChart';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { Card } from '../../../../core/components/Card';
import { getColorsByStackHalf } from '../../../../utils/random-color';

export const PieChart = ({ data, title, sx }) => {
  const { t } = useTranslation();
  const [donutChartData, setDonutChartData] = useState();
  const [hasData, setHasData] = useState(false);
  const [colors, setColors] = useState([]);

  useEffect(() => {
    if (data && t) {
      const entries = Object.entries(data);
      const colors = getColorsByStackHalf(2, entries?.length);
      setColors(colors);

      const chartData = entries.map(([key], i) => ({
        label: key,
        value:
          data?.[key]?.count || data?.[key]?.count === 0 ? data?.[key].count : data?.[key] || 0,
        color: colors[i]
      }));
      setDonutChartData(chartData);

      const aggData = chartData.reduce((prev, curr) => {
        return prev + curr.value;
      }, 0);
      setHasData(!!aggData);
    }
  }, [data, t]);

  return (
    <Card
      sx={{
        ...sx,
        maxWidth: '383px',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        minHeight: '290px'
      }}
    >
      <Box
        sx={{
          width: '100%',
          mb: 2,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <Typography
          color="#00010E"
          fontSize="1.2em"
          fontFamily={'Mulish'}
          fontWeight={600}
          letterSpacing="0.01938em"
          lineHeight="22px"
        >
          {t(title)}
        </Typography>
      </Box>
      {hasData ? (
        <DonutChart data={donutChartData} title={title} colorMapping={colors} />
      ) : (
        <Typography
          color="lightgrey"
          fontSize={20}
          position={'absolute'}
          fontWeight={600}
          fontFamily={'Mulish'}
          letterSpacing="0.01938em"
          lineHeight="22px"
          left={'50%'}
          top={'50%'}
          sx={{ transform: 'translate(-50%, -50%)' }}
          textAlign={'center'}
        >
          {t('telemetry.noData')}
        </Typography>
      )}
    </Card>
  );
};

PieChart.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  title: PropTypes.string,
  sx: PropTypes.object
};

export default PieChart;
